import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import api from '../../services/api';
import Layout from '../../components/Layout';
import { Container } from 'react-bootstrap';
import TopBar from '../../components/TopBar';

const LeaveHistory = ({ token }) => {
  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    api.get('/leaves')
      .then(res => setLeaves(res.data));
  }, []);

  return (
  
        <Container fluid className="mt-4">
            <Table bordered striped className="mt-4">
              <thead>
                <tr>
                  <th>Type</th><th>Start</th><th>End</th><th>Status</th>
                </tr>
              </thead>
              <tbody>
                {leaves.map((l, i) => (
                  <tr key={i}>
                    <td>{l.type.name}</td>
                    <td>{l.start_date}</td>
                    <td>{l.end_date}</td>
                    <td>{l.status}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
        </Container>
  );
};

export default LeaveHistory;